// extracted by mini-css-extract-plugin
export default {"sceneViewer":"shape_viewer_sceneViewer__16vTH","overlay":"shape_viewer_overlay__2CNnl","overlayActive":"shape_viewer_overlayActive__INcvC","svg":"shape_viewer_svg__hMXwd"};